// A page has one sign-in dialog and several buttons that open it (header bar,
// mobile menu). The buttons and the dialog meet here.

type Listener = (opener: HTMLElement) => void;

const listeners = new Set<Listener>();

export function onOpenSignIn(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function openSignIn(opener: HTMLElement): void {
  for (const listener of listeners) listener(opener);
}
